module.exports = __webpack_public_path__ + "img/accruedDomonetization.2b9b4dea.svg";